import type { Region } from '@/types/constants';
import type { SetState } from '../store';
import type { Experiment } from '@/types/aggregation/home';

export type GlobalsSliceProps = {
    globals: {
        platform: string;
        isDesktop: boolean;
        isMobile: boolean;
        isAndroid: boolean;
        isAndroidWrapper: boolean;
        isIos: boolean;
        isIosWrapper: boolean;

        region: Region;
        isLoggedIn: boolean;
        currentRoute: string;

        featureFlags: Record<string, true>;
        experiments: Experiment;

        setPlatform: (platform: string) => void;
        setIsDesktop: (isDesktop: boolean) => void;
        setIsMobile: (isMobile: boolean) => void;
        setIsAndroid: (isAndroid: boolean) => void;
        setIsAndroidWrapper: (isAndroidWrapper: boolean) => void;
        setIsIos: (isIos: boolean) => void;
        setIsIosWrapper: (isIosWrapper: boolean) => void;

        setRegion: (region: string) => void;
        setIsLoggedIn: (isLoggedIn: boolean) => void;
        setCurrentRoute: (currentRoute: string) => void;

        setfeatureFlags: (featureFlags: Record<string, true>) => void;
        setExperiments: (experiments: Experiment) => void;
    };
};

/**
 * @deprecated
 */
export const globalsSlice = ({ set }: SetState<GlobalsSliceProps>): GlobalsSliceProps => ({
    globals: {
        platform: '',
        isDesktop: false,
        isMobile: false,
        isAndroid: false,
        isAndroidWrapper: false,
        isIos: false,
        isIosWrapper: false,

        region: 'MI',
        isLoggedIn: false,
        currentRoute: '',

        featureFlags: {} as Record<string, true>,
        experiments: {} as Experiment,
        setPlatform: (platform: string) =>
            set(
                (state) => ({
                    globals: {
                        ...state.globals, // TODO: discuss using Immer https://immerjs.github.io/immer/
                        platform
                    }
                }),
                undefined,
                'setPlatform'
            ),
        setIsMobile: (isMobile: boolean) =>
            set(
                (state) => ({
                    globals: {
                        ...state.globals,
                        isMobile
                    }
                }),
                undefined,
                'setIsMobile'
            ),
        setIsAndroid: (isAndroid: boolean) =>
            set(
                (state) => ({
                    globals: {
                        ...state.globals,
                        isAndroid
                    }
                }),
                undefined,
                'setIsAndroid'
            ),
        setIsAndroidWrapper: (isAndroidWrapper: boolean) =>
            set(
                (state) => ({
                    globals: {
                        ...state.globals,
                        isAndroidWrapper
                    }
                }),
                undefined,
                'setIsAndroidWrapper'
            ),
        setIsIos: (isIos: boolean) =>
            set(
                (state) => ({
                    globals: {
                        ...state.globals,
                        isIos
                    }
                }),
                undefined,
                'setIsIos'
            ),
        setIsIosWrapper: (isIosWrapper: boolean) =>
            set(
                (state) => ({
                    globals: {
                        ...state.globals,
                        isIosWrapper
                    }
                }),
                undefined,
                'setIsIosWrapper'
            ),
        setIsDesktop: (isDesktop: boolean) =>
            set(
                (state) => ({
                    globals: {
                        ...state.globals,
                        isDesktop
                    }
                }),
                undefined,
                'setIsDesktop'
            ),
        setRegion: (region: string) =>
            set(
                (state) => ({
                    globals: {
                        ...state.globals,
                        region
                    }
                }),
                undefined,
                'setRegion'
            ),
        setIsLoggedIn: (isLoggedIn: boolean) =>
            set(
                (state) => ({
                    globals: {
                        ...state.globals,
                        isLoggedIn
                    }
                }),
                undefined,
                'setIsLoggedIn'
            ),
        setCurrentRoute: (currentRoute: string) =>
            set(
                (state) => ({
                    globals: {
                        ...state.globals,
                        currentRoute
                    }
                }),
                undefined,
                'setCurrentRoute'
            ),
        setfeatureFlags: (featureFlags: Record<string, true>) =>
            set((state) => ({
                globals: {
                    ...state.globals,
                    featureFlags
                }
            })),
        setExperiments: (experiments: Experiment) =>
            set((state) => ({
                globals: {
                    ...state.globals,
                    experiments
                }
            }))
    }
});
